import { mandarErroDaTela } from '../utils/erroDaTela.js';
import React, { Suspense } from 'react';

/* ══ A MOLDURA DA SALA BAIXADA SOB DEMANDA (V1849) — espera o pedaço chegar e, se ele não vier, EXPLICA.
   Substitui o ErrorBoundary antigo (modelo velho, card/btn, que ninguém mais usava).
   O caso que importa: sem rede, numa sala que este aparelho ainda não baixou. Sem esta moldura, a falha do
   pedaço derrubava a árvore inteira — a tela branca. Com ela, a pessoa lê o que fazer. ══ */
class Moldura extends React.Component {
  constructor(props) { super(props); this.state = { erro: null }; }
  static getDerivedStateFromError(erro) { return { erro }; }
  componentDidCatch(erro, info) { console.error('[sala sob demanda]', erro, info?.componentStack); mandarErroDaTela(`A sala não abriu (${erro?.message || erro})`, info?.componentStack); }   // (V1892) vai para "O sistema"
  render() {
    if (!this.state.erro) return this.props.children;
    const semRede = typeof navigator !== 'undefined' && !navigator.onLine;
    return (
      <div className="sala-container">
        <div className={`aviso ${semRede ? 'atencao' : 'perigo'}`}>
          <span>{semRede
            ? <><b>Sem internet, e esta sala ainda não foi baixada neste aparelho.</b> Abra-a uma vez com rede e ela passa a abrir sem internet.</>
            : <><b>A sala não carregou.</b> Pode ter saído uma versão nova do sistema enquanto a tela estava aberta — tente de novo.</>}</span>
          <button type="button" className="acao acao-m acao-contorno aviso-acao" onClick={() => window.location.reload()}>Tentar de novo</button>
        </div>
      </div>);
  }
}
export default function SalaSobDemanda({ children }) {
  return <Moldura><Suspense fallback={<p className="fila-s">Carregando a sala…</p>}>{children}</Suspense></Moldura>;
}
